<template>
    <div>
        <transition name="slide-fade" appear>
            <b-row>
                <EncabezadoDocente/>
                <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col md="5">
                                <b-form-group label="Lista de Aulas:" label-for="aulas">
                                    <b-form-select id="aulas" v-model="idAsignaturaDocente" :options="listaComboAsignaturasDocente" @change="cargaActividades()">
                                        <template slot="first"><option :value="null" disabled>-- Seleccione un Aula --</option></template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="7">
                                <b-form-group label="Lista de Actividades:" label-for="actividades">
                                    <b-form-select id="actividades" v-model="idActividad" :options="listaComboActividades" @change="cargaTareasActividad()">
                                        <template slot="first"><option :value="null" disabled>-- Seleccione una Actividad --</option></template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-row>
                        <b-col>
                            <vue-good-table
                                :columns="titulos"
                                :line-numbers="true"
                                :search-options="{
                                    enabled: true,
                                    placeholder: 'Buscar...'
                                }"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'registros',
                                    nextLabel: 'Siguiente',
                                    prevLabel: 'Anterior',
                                    rowsPerPageLabel: 'Filas por página',
                                    ofLabel: 'de',
                                    pageLabel: 'página',
                                    allLabel: 'Todo'
                                }"
                                styleClass="vgt-table bordered condensed striped sm"
                                :rows="listaEstudiantesAulaTareas"
                                >
                                <div slot="table-actions">
                                    <b-button variant="primary" size="sm" class="mr-2 ml-5" v-b-tooltip.hover title="Recargar Tareas" @click="cargaTareasActividad()"><i class="fas fa-sync-alt"></i></b-button>
                                </div>
                                <template slot="table-row" slot-scope="props">
                                    <div v-if="props.column.field === 'estudiante'">
                                        <span>{{ props.row.estudiante }}</span>
                                    </div>
                                    <div v-if="props.column.field === 'documento'">
                                        <span>{{ props.row.documento }}</span>
                                    </div>
                                    <div v-if="props.column.field === 'tarea'">
                                        <a href="#" @click="revisarTareaEstudiante(props.row)">
                                            {{ props.row.tarea }}
                                            <span v-if="props.row.adjunto"><i class="fas fa-paperclip"></i></span>
                                        </a>
                                    </div>
                                    <div v-if="props.column.field === 'revisada'">
                                        <div v-if="props.row.tarea">
                                            <div v-if="props.row.revisada" class="text-success">Revisada</div>
                                            <div v-else class="text-danger">Sin Revisar</div>
                                        </div>
                                    </div>
                                    <div v-if="props.column.field === 'nota'">
                                        <span>{{ props.row.nota }}</span>
                                    </div>
                                    <span v-if="props.column.field === 'mensajes_sin_leer_docente'">
                                        <div v-if="props.row.tarea">
                                            <a href="#" @click="contenidoMensaje=props.row.mensajes, verModalMensajes=true, idTareaMensaje=props.row.id_tarea, numeroMensajesSinLeer=props.row.mensajes_sin_leer_docente">
                                                <i class="fas fa-bell"></i>
                                                <b-badge variant="success" v-if="props.row.mensajes_sin_leer_docente">{{ props.row.mensajes_sin_leer_docente }}</b-badge>
                                            </a>
                                        </div>
                                    </span>
                                </template>
                            </vue-good-table>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </transition>

        <b-modal scrollable size="xl" :title="'Revisar Tarea del Estudiante [#'+idTarea+']'" header-bg-variant="success" header-text-variant="light" v-model="verModalTarea">
            <b-card-text>
                <div class="container">
                    <b-row>
                        <b-col lg="7">
                            <div class="mt-2">Actividad:<br><strong>{{ this.tituloActividad }}</strong></div>
                        </b-col>
                        <b-col lg="5">
                            <div class="mt-2">Fecha Tarea:<br><strong>{{ this.fechaTarea }}</strong></div>
                        </b-col>
                        <b-col lg="7">
                            <div class="mt-2">Estudiante:<br><strong>{{ this.estudianteTarea }}</strong></div>
                        </b-col>
                        <b-col lg="5">
                            <div class="mt-2">Ultima Revisión:<br><strong>{{ this.fechaRevisionTarea }}</strong></div>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col lg="12">
                            <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" disabled></ckeditor>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col lg="12">
                            <div class="float-right mr-3">Fecha de Carga: {{ fechaAdjuntoTarea }}</div>
                            <label><strong>Archivo Adjunto:</strong></label>
                            <b-card bg-variant="light">
                                <b-card-text>
                                    <div v-if="linkAdjunto === null">
                                        <label class="text-danger">No se adjuntaron archivos</label><br>
                                    </div>
                                    <div v-else>
                                        <p>{{ this.adjuntoTarea }}
                                            <a class="btn btn-primary btn-sm ml-5" :href="this.linkAdjunto" target="_blank">Descargar</a>
                                        </p>
                                    </div>
                                </b-card-text>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col lg="12">
                            <label><strong>Mensajes:</strong></label>
                            <b-form-textarea v-model="mensajesTarea" placeholder="Sin Mensajes" rows="8" disabled></b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2 mb-2">
                        <b-col lg="12">
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-input-group-text><strong class="text-primary"><i class="fas fa-comment-dots"></i></strong></b-input-group-text>
                                </template>
                                <b-form-input v-model="nuevoMensaje" placeholder="Nuevo mensaje..."></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col lg="12">
                            <label><strong>Evaluación:</strong></label>
                            <b-card bg-variant="light">
                                <b-card-text>
                                    <b-col lg="12">
                                        <label for="input-default">Calificación / Nota:</label>
                                    </b-col>
                                    <b-col lg="2" sm="4" cols="6">
                                        <b-form-input type="number" id="nota" v-model="notaTarea"></b-form-input>
                                    </b-col>
                                </b-card-text>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </b-card-text>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="success" @click="tareaRevisada()"> Dar por Revisada la Tarea</b-button>
                <b-button size="sm" variant="" @click="cancel()"> Cancelar </b-button>
            </template>
        </b-modal>

        <b-modal scrollable :title="'Mensajes [#'+idTareaMensaje+']'" header-bg-variant="success" header-text-variant="light" v-model="verModalMensajes">
            <b-card-text>
                <b-form-textarea cols="74" rows="18" :placeholder="contenidoMensaje" disabled></b-form-textarea>
            </b-card-text>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <div v-if="numeroMensajesSinLeer">
                    <b-button size="sm" variant="success" @click="mensajesLeidos()"> Dar por leidos los Mensajes</b-button>
                </div>
                <b-button size="sm" variant="" @click="cancel()">Cerrar </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import * as CONFIG from '@/assets/config.js'
    import EncabezadoDocente from '@/containers/EncabezadoDocente'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    export default {
        name: 'RevisarTareas',
        components: {
            EncabezadoDocente,
        },
        data() {
            return {
                asignaturasDocente: [],
                listaComboAsignaturasDocente: [],
                idAsignaturaDocente: null,
                descripcionAsignaturasGrados: [],
                actividadesAula: [],
                listaComboActividades: [],
                idActividad: null,
                idCurso: '',
                listaEstudiantesAula: [],
                listaEstudiantesAulaTareas: [],
                titulos: [
                    { label: "NOMBRE ESTUDIANTE", field: "estudiante", sortable: false },
                    { label: "DOCUMENTO", field: "documento", sortable: false },
                    { label: "TAREA", field: "tarea", sortable: false },
                    { label: "ESTADO", field: "revisada", sortable: false },
                    { label: "NOTA", field: "nota", sortable: false },
                    { label: "MSG", field: "mensajes_sin_leer_docente", sortable: false }
                ],
                tareasActividad: [],
                tituloActividad: '',
                estudianteTarea: '',
                verModalTarea: false,
                editor: ClassicEditor,
                editorData: '',
                editorConfig: {},
                idTarea: '',
                mensajesTarea: '',
                notaTarea: '',
                mensajes_sin_leer_estudiante: '',
                adjuntoTarea: null,
                linkAdjunto: null,
                nuevoMensaje: null,
                fechaTarea: null,
                fechaRevisionTarea: null,
                fechaAdjuntoTarea: null,
                verModalMensajes: false,
                contenidoMensaje: null,
                idTareaMensaje: null,
                numeroMensajesSinLeer: null
            }
        },
        methods: {
            mensajesLeidos() {
                let datosTarea = { id: this.idTareaMensaje, bd: this.$store.state.bdColegio }
                axios
                .put(CONFIG.ROOT_PATH + "tarea/mensajesleidos/docente", JSON.stringify(datosTarea), { headers: {"Content-Type": "application/json; charset=utf-8" }})
                .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                    }
                })
                this.cargaTareasActividad()
                this.verModalMensajes = false
            },
            async tareaRevisada() {
                let fechaAhora = new Date()
                let ano = fechaAhora.getFullYear()
                let mes = fechaAhora.getMonth() + 1
                let dia = fechaAhora.getDate()
                let datosTareaRevisada = {}
                datosTareaRevisada.id = this.idTarea
                if (this.nuevoMensaje != ''){
                    this.mensajesTarea = '--- ' + this.$store.state.nombresUsuario + ' ' + this.$store.state.apellidosUsuario + ' el ' + fechaAhora.toLocaleDateString() + ' ' + fechaAhora.toLocaleTimeString() + '\n' + this.nuevoMensaje + '\n\n' + this.mensajesTarea
                    this.mensajes_sin_leer_estudiante++
                }
                datosTareaRevisada.sinleerEstudiante = this.mensajes_sin_leer_estudiante
                datosTareaRevisada.mensajes = this.mensajesTarea
                datosTareaRevisada.nota = this.notaTarea
                datosTareaRevisada.revisada = 1
                datosTareaRevisada.bd = this.$store.state.bdColegio
                datosTareaRevisada.fecha_revision = ano + '-' + mes + '-' + dia + ' ' + fechaAhora.toLocaleTimeString()
                await axios
                .put(CONFIG.ROOT_PATH + "tareas/docente", JSON.stringify(datosTareaRevisada),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
                .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                this.cargaTareasActividad()
                this.verModalTarea = false
            },
            revisarTareaEstudiante(estudianteSeleccionado) {
                this.tituloActividad = document.getElementById("actividades").options[document.getElementById("actividades").selectedIndex].text
                this.idTarea = estudianteSeleccionado.id_tarea
                this.estudianteTarea = estudianteSeleccionado.estudiante
                this.editorData = estudianteSeleccionado.contenido
                this.mensajesTarea = estudianteSeleccionado.mensajes
                if (this.mensajesTarea == null)
                    this.mensajesTarea = ''
                this.nuevoMensaje = ''
                this.notaTarea = estudianteSeleccionado.nota
                this.mensajes_sin_leer_estudiante = estudianteSeleccionado.mensajes_sin_leer_estudiante
                if (estudianteSeleccionado.adjunto == null || estudianteSeleccionado.adjunto == ''){
                    this.adjuntoTarea = null
                    this.linkAdjunto = null
                } else {
                    this.adjuntoTarea = estudianteSeleccionado.adjunto
                    this.linkAdjunto = 'https://sised.com.co/APISised/colegios/' + this.$store.state.bdColegio + '/descargas/aulas/' + this.adjuntoTarea
                }
                let fecha = new Date(estudianteSeleccionado.fecha_tarea)
                this.fechaTarea = fecha.toLocaleDateString() + ' a las ' + fecha.toLocaleTimeString()
                this.fechaRevisionTarea = ''
                if (estudianteSeleccionado.fecha_revision) {
                    fecha = new Date(estudianteSeleccionado.fecha_revision)
                    this.fechaRevisionTarea = fecha.toLocaleDateString() + ' a las ' + fecha.toLocaleTimeString()
                }
                this.fechaAdjuntoTarea = 'No aplica'
                if (estudianteSeleccionado.fecha_adjunto) {
                    fecha = new Date(estudianteSeleccionado.fecha_adjunto)
                    this.fechaAdjuntoTarea = fecha.toLocaleDateString() + ' a las ' + fecha.toLocaleTimeString()
                }
                this.verModalTarea = true
            },
            async cargaTareasActividad() {
                this.listaEstudiantesAulaTareas = []
                await axios
                .get(CONFIG.ROOT_PATH + "aula/tareas/actividad", { params: { bd: this.$store.state.bdColegio, idactividad: this.idActividad }})
                    .then(response => {
                    if (response.data.datos) {
                        // Campos: 
                        this.tareasActividad = response.data.datos
                    } else {
                        this.tareasActividad = []
                    }
                })
                .catch(err => {
                    if (err.message === "Network Error")
                        this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                    else
                        this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                //alert(this.tareasActividad)
                for (let j = 0; j < this.listaEstudiantesAula.length; j++) {
                    this.listaEstudiantesAula[j].id_tarea = ''
                    this.listaEstudiantesAula[j].contenido = ''
                    this.listaEstudiantesAula[j].fecha_tarea = ''
                    this.listaEstudiantesAula[j].fecha_revision = ''
                    this.listaEstudiantesAula[j].revisada = ''
                    this.listaEstudiantesAula[j].mensajes = ''
                    this.listaEstudiantesAula[j].nota = ''
                    this.listaEstudiantesAula[j].adjunto = ''
                    this.listaEstudiantesAula[j].fecha_adjunto = ''
                    this.listaEstudiantesAula[j].mensajes_sin_leer_docente = ''
                    this.listaEstudiantesAula[j].mensajes_sin_leer_estudiante = ''
                    this.listaEstudiantesAula[j].tarea = ''
                }
                for (let i = 0; i < this.tareasActividad.length; i++) {
                    for (let j = 0; j < this.listaEstudiantesAula.length; j++) {
                        if (this.tareasActividad[i].id_matricula == this.listaEstudiantesAula[j].id_matricula && this.tareasActividad[i].id_actividad == this.idActividad) {
                            this.listaEstudiantesAula[j].id_tarea = this.tareasActividad[i].id
                            this.listaEstudiantesAula[j].contenido = this.tareasActividad[i].contenido
                            this.listaEstudiantesAula[j].fecha_tarea = this.tareasActividad[i].fecha_tarea
                            this.listaEstudiantesAula[j].fecha_revision = this.tareasActividad[i].fecha_revision
                            this.listaEstudiantesAula[j].revisada = this.tareasActividad[i].revisada
                            this.listaEstudiantesAula[j].mensajes = this.tareasActividad[i].mensajes
                            this.listaEstudiantesAula[j].nota = this.tareasActividad[i].nota
                            this.listaEstudiantesAula[j].adjunto = this.tareasActividad[i].adjunto
                            this.listaEstudiantesAula[j].fecha_adjunto = this.tareasActividad[i].fecha_adjunto
                            this.listaEstudiantesAula[j].mensajes_sin_leer_docente = this.tareasActividad[i].mensajes_sin_leer_docente
                            this.listaEstudiantesAula[j].mensajes_sin_leer_estudiante = this.tareasActividad[i].mensajes_sin_leer_estudiante
                            this.listaEstudiantesAula[j].tarea = 'Ver Tarea'
                        }
                    }
                }
                this.listaEstudiantesAulaTareas = this.listaEstudiantesAula
            },
            async cargaActividades() {
                await axios
                .get(CONFIG.ROOT_PATH + "actividades/aula", { params: { bd: this.$store.state.bdColegio, idasignaturadocente: this.idAsignaturaDocente }})
                    .then(response => {
                    if (response.data.error){
                        this.listaComboActividades = []
                        this.idActividad = null
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.actividadesAula = response.data.datos
                        this.listaComboActividades = []
                        this.idActividad = null
                        this.actividadesAula.forEach(element => {
                            this.listaComboActividades.push({value: element.id, text: element.titulo})
                        });
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                this.listaEstudiantesAulaTareas = []
                this.cargaEstudiantesAula()        
            },
            async cargaEstudiantesAula() {
                this.idCurso = ''
                this.asignaturasDocente.forEach(element => {
                    if (element.id_asignatura_docente == this.idAsignaturaDocente) {
                        this.idCurso = element.id_curso
                    }
                });
                await axios
                .get(CONFIG.ROOT_PATH + "listas/aula", { params: { bd: this.$store.state.bdColegio, idcurso: this.idCurso, lectivo: this.$store.state.lectivoColegio }})
                    .then(response => {
                    if (response.data.error){
                        this.listaEstudiantesAula = []
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.listaEstudiantesAula = response.data.datos
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
            },
            async cargarAsignaturasDocente() {
                await axios
                .get(CONFIG.ROOT_PATH + "asignaturas/docente", { params: { bd: this.$store.state.bdColegio, id: this.$store.state.idUsuario, lectivo: this.$store.state.lectivoColegio }})
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.asignaturasDocente = response.data.datos
                        for (let i = 0; i < this.asignaturasDocente.length; i++) {
                            for (let j = 0; j < this.descripcionAsignaturasGrados.length; j++) {
                                if (this.asignaturasDocente[i].id_asignatura_grado == this.descripcionAsignaturasGrados[j].id_asignatura_grado) {
                                    this.listaComboAsignaturasDocente.push({value: this.asignaturasDocente[i].id_asignatura_docente, text: this.asignaturasDocente[i].nomenclatura + ' | ' + this.descripcionAsignaturasGrados[j].descripcion})
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })                
            },
            async cargarDescripcionAsignaturasGrados() {
                await axios
                .get(CONFIG.ROOT_PATH + "asignaturas/descripcionasignaturasgrados", { params: { bd: this.$store.state.bdColegio, lectivo: this.$store.state.lectivoColegio }})
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.descripcionAsignaturasGrados = response.data.datos
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
            },
            validarSesion() {
                if (this.$store.state.idUsuario == '' || this.$store.state.idUsuario == null) {
                    this.$router.push("/pages/sesionfinalizada")
                } else {
                    this.cargarDescripcionAsignaturasGrados()
                    this.cargarAsignaturasDocente()
                }
            },
            mensajeEmergente(variante, titulo, contenido) {
                this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false });
            }
        },
        mounted() {
            this.validarSesion()
        },
        computed: {
        }
    }
</script>